module.exports = "/assets/data/9b1e246c7715137db23323848152df80-IP22.data.json";